import { actionType } from './actions';

const initialState = {
    addNewPortfolio: {
        trustId: '',
        edgarSeriesId: '',
        name: '',
        formerlyKnownAsNames: '',
        clientCode: '',
        feid: '',
        fundType: '',
        federalId: ''
    },
    editPortfolio: {
        portfolioId: '',
        trustId: '',
        edgarSeriesId: '',
        name: '',
        formerlyKnownAsNames: '',
        clientCode: '',
        feid: '',
        fundType: '',
        federalId: ''
    },
    viewPortfolio: {
        portfolioId: '',
        trustId: '',
        edgarSeriesId: '',
        name: '',
        formerlyKnownAsNames: '',
        clientCode: '',
        feid: '',
        fundType: '',
        federalId: ''
    },
    selectedHistoryItem: {},
    portfolios: [],
    filings: [],
    sales: [],
    adminSales: [],
    history: [],
    parentTrusts: null,
    trustId: null,
    addPortfolioVisibility: false,
    editPortfolioVisibility: false,
    viewPortfolioVisibility: false,
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_PORTFOLIO_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_PORTFOLIO_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_PORTFOLIO: {
            return {
                ...state,
                editPortfolio: action.payload,
                viewPortfolio: action.payload,
                parentTrusts: action.parentTrusts,
                sales: [],
                adminSales: [],
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PORTFOLIO_BY_ID: {
            return {
                ...state,
                editPortfolio: action.payload,
                viewPortfolio: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PORTFOLIO_BY_TRUST: {
            return {
                ...state,
                portfolios: action.payload,
                trustId: action.trustId,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PORTFOLIO_FILINGS: {
            return {
                ...state,
                filings: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PORTFOLIO_SALES: {
            return {
                ...state,
                sales: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PORTFOLIO_ADMIN_SALES: {
            return {
                ...state,
                adminSales: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PORTFOLIO_HISTORY: {
            return {
                ...state,
                history: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.ADD_NEW_PORTFOLIO: {
            return {
                ...state,
                portfolios: [action.payload, ...state.portfolios],
                addedPortfolio: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.EDIT_PORTFOLIO: {
            return {
                ...state,
                portfolios: state.portfolios.map(portfolio => {
                    if (portfolio.portfolioId === action.payload.portfolioId) {
                        return action.payload;
                    }
                    return portfolio;
                }),
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_ADD_NEW_PORTFOLIO_PAYLOAD: {
            return {
                ...state,
                addNewPortfolio: action.payload
            };
        }

        case actionType.UPDATE_EDIT_PORTFOLIO_PAYLOAD: {
            return {
                ...state,
                editPortfolio: action.payload
            };
        }

        case actionType.UPDATE_PORTFOLIO_HISTORY_ITEM_SELECTED: {
            return {
                ...state,
                selectedHistoryItem: action.payload
            };
        }

        case actionType.HANDLE_ADD_PORTFOLIO_VISIBILITY: {
            return {
                ...state,
                addPortfolioVisibility: action.visibility,
                addNewPortfolio: {
                    trustId: '',
                    edgarSeriesId: '',
                    name: '',
                    formerlyKnownAsNames: '',
                    clientCode: '',
                    feid: '',
                    fundType: ''
                }
            };
        }

        case actionType.HANDLE_EDIT_PORTFOLIO_VISIBILITY: {
            return {
                ...state,
                editPortfolioVisibility: action.visibility
            };
        }

        case actionType.HANDLE_VIEW_PORTFOLIO_VISIBILITY: {
            return {
                ...state,
                viewPortfolioVisibility: action.visibility
            };
        }

        case actionType.CLEAR_PORTFOLIOS_LIST: {
            return {
                ...state,
                portfolios: []
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/portfolio/reducers.js